const url = 'cash_boxes';
import { api } from "api";
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form'
import { createActions, handleActions } from 'redux-actions'

const LOADER_CAJA = 'LOADER_CAJA';
const SET_DATA_CAJA = 'SET_DATA_CAJA';
const SET_PAGE_CAJA = 'SET_PAGE_CAJA';
const SET_UPDATE_DATA_CAJA ='SET_UPDATE_DATA_CAJA';
const SET_BUSCADOR_CAJA = 'SET_BUSCADOR_CAJA';
const SET_FILTRO_CAJA = 'SET_FILTRO_CAJA';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_CAJA, cargando: true});
    const store = getStore();
    const search = store.cashBoxes.buscador;
    const filtro = store.cashBoxes.filtro_cajas;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_CAJA, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_CAJA, data});
            dispatch({type: SET_PAGE_CAJA, page});
        }
        dispatch({type: LOADER_CAJA, cargando: false});
    })
};
const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_CAJA, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_CAJA, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/cash-boxes'))
        }
    }).then((data) => {
        dispatch({type: LOADER_CAJA, cargando: false});
        if(data){
            data.subsidiary.value = data.subsidiary.id;
            data.subsidiary.label = data.subsidiary.name;
            dispatch({type: SET_UPDATE_DATA_CAJA, updateData: data});
            dispatch(initializeForm('cashBoxes', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.cashBoxes.values;
    formData.subsidiary = formData.subsidiary.value;
    dispatch({type: LOADER_CAJA, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_CAJA, cargando: false})
        Swal('Éxito', 'Se ha creado la caja exitosamente.', 'success')
        .then(() => {
            dispatch(push('/cash-boxes'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_CAJA, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_CAJA, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.cashBoxes.values);
    dispatch({type: LOADER_CAJA, cargando: true});
    formData.subsidiary = formData.subsidiary.value;
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_CAJA, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/cash-boxes'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_CAJA, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/cash-boxes'));
        }
    })
}
const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_CAJA, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_CAJA, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_CAJA, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_CAJA, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_CAJA, filtro_cajas: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_CAJA]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_CAJA]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_CAJA]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_CAJA]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_CAJA]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_CAJA]: (state, { filtro_cajas }) => {
        return {...state, filtro_cajas }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_cajas: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
